import './sondaggi.scss';

/**
 * version    1.0
 * class      <type> (Sondaggi)
 * classdesc  Sondaggi: question, 3 answer, percentage
 */
export class Sondaggi {}
